import React from 'react';
import { connect } from 'react-redux';
import { openPanel } from '../../Redux/Panels/RightPanel/actions';
import { closePanel } from '../../Redux/User/actions';
import { alertNotify } from "../../Components/Functions";
import Api from "../../Server/Api";
import InfoActionPage from '../../Components/InfoActionPage';
const api = new Api();

const BankUpdateForm = ( props ) => {
	const [loading, setLoading] = React.useState(true);
	const [bankCodes, setBankCodes] = React.useState(false)
	const [bankCode, setBankCode] = React.useState(props?.bank?.bank_code)
	const [acctNo, setAcctNo] = React.useState(props?.bank?.account_number)
	const [accountName, setAccountName] = React.useState(props?.bank?.account_name);
	const [data, setData] = React.useState("")
	const [btnText, setBtnText] = React.useState("Continue");
	const [isCompleted, setIsCompleted] = React.useState(false);
	const [showOtp, setShowOtp] = React.useState(false);


	const showButton = React.useMemo(() => {
		if (bankCode === props.bank.bank_code && acctNo === props.bank.account_number){
			return false;
		}
		return true;
	}, [bankCode, acctNo, props]);

	const init = async () => {
		setLoading(true);
		let res = await api.get({ endpoint: `/bank/` });
		if (res.length){
			setBankCodes(res);
		}
		setLoading(false);
	}
	
	React.useEffect(() => { init(); }, [])

  function validateAcctNumber(e){
	  if (e.target.value.length > 10){
	  	e.target.value = e.target.value.slice(0, 10);
		alertNotify({
			message:'Account number is 10 digit',
			type: 'error',
			timeout: 3
		});
	  }
	  setAcctNo(e.target.value)
  }
  function validateAcct(){
	  let len = document.getElementById("acct-number").value.length
	  if (len === 10){
		  return true
	  }
	  if (len < 10){
		alertNotify({
			message:'Account number not up to 10 digits',
			type: 'error',
			timeout: 3
		});
	  }else{
		alertNotify({
			message:'Account number more than 10 digits',
			type: 'error',
			timeout: 3
		});
	  }
	  return false
  }

  const saveBankDetails = async (e) => {
	setLoading(true);
	let res = await api.post({ endpoint: `/bank/`, 
				data: {
					secret: data.otp_secret,
					otp_code: document.getElementById("otp-pin").value,
					bank_code: data.data["bank_code"],
					account_number: data.data["account_number"],
					account_name: data.data["account_name"]
				}
			});
	setLoading(false);
	if (res?.id > 0){
		alertNotify({
			message:'Your bank details have been saved!',
			type: 'success',
			timeout: 5
		});
		setIsCompleted(true);
		return
	}
	alertNotify({
		message:'Wrong OTP pin',
		type: 'error',
		timeout: 5
	});	
	return 
  }

  const getAcctName = async (e) => {
	if (btnText === "Save Bank Details"){
		saveBankDetails()
		return 
	}
	validateAcct();
	setLoading(true);
	let res = await api.get({ endpoint: `/bank/verify_bank/`, data: {bankCode: bankCode, accountNumber: acctNo}});
	setLoading(false);
	if (res?.status){
			alertNotify({
				message:`Please enter the OTP code sent your email`,
				type: 'success',
				timeout: 15
			});
			setData(res);
			setAccountName(res?.data?.account_name)
			setBtnText("Save Bank Details");
			setShowOtp(true);
			return
	}
	alertNotify({
		message: res?.detail || res?.message || 'Incorrect Account Number',
		type: 'error',
		timeout: 5
	});	

  }


  if (isCompleted){
	return <InfoActionPage 
		title="Bank Account Updated"
		message="Your bank details have been successfully updated!"
	/>;
  }
  return (
	<>
		<div class="form-body p-5" style={{
			paddingTop: 0,
		}}>

			<style>
				{`
					input[type=number]::-webkit-inner-spin-button, 
					input[type=number]::-webkit-outer-spin-button { 
					  -webkit-appearance: none; 
					}
					
					input[type=number] {
					  -moz-appearance: textfield;
					}					
				`}
			</style>
			<div className="form-fieldset">
				<div className="columns is-multiline gh mb-4">
					<div className="field" style={{ width: "100%" }}>
						<div className="select" style={{ width: "100%", height: "40px"}}>
							<select style={{ width: "100%" }} onChange={(e) => {
									setBankCode(e.target.options[e.target.selectedIndex].getAttribute("code"));
								}
								}>
								<option>Select Bank Name</option>
								{bankCodes && bankCodes.map((code)=>{
									return <option selected={code.code === bankCode||null} code={code.code}>{code.name}</option>
								})}
							</select>
						</div>
					</div>
				</div>
			<div className="columns is-multiline gh mb-5">
				<div className="w-100">
					<input type="number" class="input" id="acct-number" maxlength="12" placeholder="Please enter your account number" onChange={(e)=> validateAcctNumber(e) } value={acctNo}/>
				</div>
			</div>
			{accountName && (
				<div className="columns is-multiline gh mb-5">
					<div className="w-100">
						<input class="input" readOnly id="acct-name" value={accountName} />
					</div>
				</div>
			)}
			{showOtp && (
				<div className="columns is-multiline gh mb-5">
				<div className="w-100">
					<input class="input" placeholder="Enter OTP pin" id="otp-pin"/>
				</div>
				</div>
			)}
			{showButton && (
				<div className="columns is-multiline gh mb-5 full-width">
					<button className={`button h-button is-primary is-bold is-raised ${loading ? "is-loading" : ""}`} id="submitBtn" onClick={(e) => getAcctName(e)}
						style={{
							display: "block",
							width: "100%"
						}}
					>{btnText}</button>
				</div>
			)}			
			</div>
		</div>
	</>
  )
}


const mapStateToProps = ({ user }) => {
	return { bank: user?.user?.bank || {} };
};

const mapDispatchToProps = (dispatch) => {
	return {
		closePanel: (e) => dispatch(closePanel(e)),
		openPanel: (e) => dispatch(openPanel(e)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(BankUpdateForm);